import BaseService from '../base.service';

export class UserService {
  // 修改密码
  static async modifyPasswordApi(postData) {
    return BaseService.post('/web/user/modifyPassword', postData);
  }
  // 获取用户余额
  static async getUserBalanceApi() {
    return BaseService.get('/web/user/balance');
  }

  // 充值
  static async toUpFeeApi(postData) {
    return BaseService.post('/web/user/toUpFee', postData);
  }
}
